import { NumberedItem } from '../../ui-components/NumberedItem'
import { EliteScoreTrends, KnowWhyAPIReponseType } from '../../../types/mutual-fund-detail.types'
import { toPascalCaseWithSpaces } from '../../../utils/utils'
import { getScoreConfig } from '../utils'
import { GradientStrip } from '../../ui-components/GradientStrip'
import { StripContent } from './StripContent'
import { formatScoreOfTotalSpeech } from './ScoreValue'

interface ConsistencyScoreSectionProps {
  knowWhyData: KnowWhyAPIReponseType
  isElite: boolean
  number: number
  isLastSection: boolean
}

export const ConsistencyScoreSection = ({
  knowWhyData,
  isElite,
  number,
  isLastSection
}: ConsistencyScoreSectionProps) => {
  const category = toPascalCaseWithSpaces(knowWhyData?.category ?? '')
  const consistencyScore = knowWhyData?.scoringDetails?.consistencyScore ?? 0
  const maxScore = knowWhyData?.scoringDetails?.maxScore ?? 100
  const tag = (knowWhyData?.scoringDetails?.consistencyScorePerformanceTag ||
    EliteScoreTrends.AVERAGE) as EliteScoreTrends
  const config = getScoreConfig(tag)
  const scoreSpeech = formatScoreOfTotalSpeech(isElite ? consistencyScore : null, maxScore, !isElite)
  const description = "Fund's consistency in giving high returns vs others in same category"
  const accessibilityLabel = [
    `Consistency Score in ${category}`,
    scoreSpeech,
    config.scoreLabel,
    description
  ].join(', ')

  return (
    <NumberedItem
      as='li'
      number={number}
      title={`Consistency Score`}
      subtitle={`in ${category}`}
      borderBottom={!isLastSection}
      accessibilityLabel={accessibilityLabel}
    >
      <GradientStrip type={config.gradientStripType}>
        <StripContent
          tag={tag}
          isElite={isElite}
          score={consistencyScore}
          maxScore={maxScore}
          description='Fund’s consistency in giving high returns <br /> vs others in same category'
        />
      </GradientStrip>
    </NumberedItem>
  )
}
